export default __webpack_public_path__ + "static/media/16_LeftToRightSquares_RotateRight.e8f5985a.mp4";